import { useAtomValue } from "jotai";
import { CurrentOfflineDeviceAtom } from "utilities/atoms/current-offline-device-atom";

export default function useOfflineDevice() {
    const currentOfflineDevice = useAtomValue(CurrentOfflineDeviceAtom);

    return { resultObject: currentOfflineDevice };
}
